const DOCUMENTATION = "https://docs.switchboard-software.com/";
const CONNECTORS = "https://docs.switchboard-software.com/connectors/";
const QUICKSTART = "https://docs.switchboard-software.com/switchboard-script/quickstart/";
const TEST_RUNS_SUPPORT = "https://docs.switchboard-software.com/switchboard-script/quickstart/#draft-a-recipe";

export { DOCUMENTATION, CONNECTORS, QUICKSTART, TEST_RUNS_SUPPORT };
